import "./App.css";

function App() {
  return (
    <div className="login-container">
      <h2>Login</h2>

      <form>
        <input type="email" placeholder="Email" />
        <input type="password" placeholder="Password" />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default App;
